<template>
  <div class="map-compare">
    <a title="Compare Maps" @click="$router.go(-1)" tag="a" class="back-icon is-info button is-small is-uppercase">
      <span class="icon">
        <i class="fas fa-arrow-left"></i>
      </span>
      <span v-if="lang_data">{{ localization("app-back", "Back") }}</span>
    </a>
    <div class="project-dropdown-container" v-if="container">
      <div class="project-dropdown project-dropdown--before">
        <treeselect
          :multiple="true"
          :normalizer="project_custom_keys"
          :options="project_options"
          :disable-branch-nodes="true"
          :placeholder="localization('app-select-project', 'Select Project')"
          @select="compare($event, beforeMap)"
          @deselect="compare($event, beforeMap)"
          value-format="object"
        />
      </div>
      <div class="project-dropdown project-dropdown--after">
        <treeselect
          :multiple="true"
          :normalizer="project_custom_keys"
          :options="project_options"
          :disable-branch-nodes="true"
          :placeholder="localization('app-select-project', 'Select Project')"
          @select="compare($event, afterMap)"
          @deselect="compare($event, afterMap)"
          value-format="object"
        />
      </div>
    </div>
    <div id="before"></div>
    <div id="after"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      beforeMap: null,
      afterMap: null,
      metas: {},
    };
  },
  mounted() {
    this.beforeMap = new mapboxgl.Map({
      container: "before",
      style: "mapbox://styles/mapbox/satellite-v8",
      center: [0, 0],
      zoom: 0,
    });

    this.afterMap = new mapboxgl.Map({
      container: "after",
      style: "mapbox://styles/mapbox/satellite-v8",
      center: [0, 0],
      zoom: 0,
    });

    var map = new mapboxgl.Compare(this.beforeMap, this.afterMap, {
      // Set this to enable comparing two maps by mouse movement:
      //   mousemove: true
    });
  },
  computed: {
    ...mapState(["container"]),
    project_options() {
      return this.container.groups;
    },
  },
  methods: {
    project_custom_keys(node) {
      return {
        id: node.uid,
        label: node.name,
        children: node.projects,
      };
    },
    async compare(layer, map) {
      if (!layer.reports || !layer.reports.orthotiles || !layer.reports.orthotiles.tile_url) return;

      if (!map.getSource("MAPSOURCE:" + String(layer.uid)))
        map.addSource("MAPSOURCE:" + String(layer.uid), {
          type: "raster",
          tiles: [`${layer.reports.orthotiles.tile_url}/{z}/{x}/{y}.png`],
          tileSize: 256,
        });

      if (map.getLayer("MAPLAYER:" + String(layer.uid))) {
        var visibility = map.getLayoutProperty("MAPLAYER:" + String(layer.uid), "visibility");
        if (visibility === "visible") {
          map.setLayoutProperty("MAPLAYER:" + String(layer.uid), "visibility", "none");
        } else {
          map.setLayoutProperty("MAPLAYER:" + String(layer.uid), "visibility", "visible");
          map.flyTo({
            center: this.metas[layer.uid].center.slice(0, 2),
            zoom: 15,
            speed: 4,
          });
        }
      } else {
        map.addLayer({
          id: "MAPLAYER:" + String(layer.uid),
          type: "raster",
          source: "MAPSOURCE:" + String(layer.uid),
        });
        map.setLayoutProperty("MAPLAYER:" + String(layer.uid), "visibility", "visible");
        let results = await axios.get(layer.reports.orthotiles.tile_url);
        let meta = results.data;
        this.metas[layer.uid] = meta;
        map.flyTo({
          center: meta.center.slice(0, 2),
          zoom: 15,
          speed: 4,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#after,
#before {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
.back-icon {
  position: absolute;
  z-index: 100;
  bottom: 1.5rem;
  right: 1rem;
}
.project-dropdown {
  position: absolute;
  z-index: 1000;
  width: 250px;
  top: 1rem;
  &--before {
    left: 1rem;
  }
  &--after {
    right: 1rem;
  }
}
.vue-treeselect {
  width: 90%;
  &__control {
    color: inherit;
    border: none;
    background: #f4f6fb;
    border-radius: 2px;
    border-bottom: 2px solid transparent;
  }
  &__multi-value-item {
    background: #344257;
    color: white;
  }
  &__multi-value {
    padding: 5px;
  }
  &__menu {
    max-height: 130px !important;
  }
  &__value-remove {
    color: #fff;
  }
  &__multi-value-label {
    padding: 2px 8px;
  }
  &__checkbox--indeterminate,
  &__label-container:hover &__checkbox--indeterminate {
    border-color: #344257;
    background: #344257;
  }
  &__checkbox--unchecked,
  &__label-container:hover &__checkbox--unchecked {
    border-color: #344257;
    background: white;
  }
  &__checkbox--checked,
  &__label-container:hover &__checkbox--checked {
    border-color: white;
    background: #344257;
  }
}
</style>
